export function urlBase64ToUint8Array(value:string):Uint8Array<ArrayBuffer>{
  const padding='='.repeat((4-value.length%4)%4);
  const base64=(value+padding).replace(/-/g,'+').replace(/_/g,'/');
  const bytes=Uint8Array.from(atob(base64),character=>character.charCodeAt(0));
  return new Uint8Array(bytes.buffer);
}
